import { Link } from 'react-router-dom';
import { hotRank, timeSlots } from '@/mocks/feed';
import HeatMeter from '@/components/base/HeatMeter';
import SectionHeading from '@/components/base/SectionHeading';

export default function HotBoard() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="Realtime Board"
        title="实时热榜，正在被讨论的话题"
        desc="按夜间讨论增速排出的相对热度，只用来判断话题在哪个位置，不代表任何事实结论。"
        action={
          <Link
            to="/feed"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-500/50 hover:text-primary-300"
          >
            全部条目
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <ol className="lg:col-span-7 divide-y divide-background-200/70 overflow-hidden rounded-lg border border-background-200/70 bg-background-100/50">
          {hotRank.map((item, index) => (
            <li key={item.slug}>
              <Link
                to={`/article/${item.slug}`}
                className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-6 md:py-5"
              >
                <span
                  className={`font-display text-2xl leading-none tracking-wide md:text-3xl ${
                    index === 0 ? 'text-primary-400' : index < 3 ? 'text-accent-400' : 'text-foreground-500'
                  }`}
                >
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-300 md:text-base">
                    {item.title}
                  </span>
                  <span className="mt-2 flex items-center">
                    <HeatMeter value={item.heat} tag={item.tag} />
                  </span>
                </span>
                <i className="ri-arrow-right-up-line shrink-0 text-lg text-foreground-500 transition-colors group-hover:text-primary-300" />
              </Link>
            </li>
          ))}
        </ol>

        <aside className="lg:col-span-5 rounded-lg border border-background-200/70 bg-background-100/50 p-5 md:p-6">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <i className="ri-timer-flash-line text-accent-400" />
            今晚的节奏表
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            不同时段的传播环境差别很大，我们把整夜拆成五档，方便你判断一条消息大概出现在哪个阶段。
          </p>
          <ul className="mt-5 space-y-3">
            {timeSlots.map((slot) => (
              <li key={slot.key} className="rounded-md border border-background-200/70 bg-background-50/60 p-3.5">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-label text-sm text-foreground-900">{slot.key}</span>
                  <span className="font-label text-xs tabular-nums text-accent-400">{slot.range}</span>
                </div>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{slot.desc}</p>
              </li>
            ))}
          </ul>
          <p className="mt-5 flex items-start gap-2 rounded-md border border-accent-500/25 bg-accent-500/10 px-3 py-2.5 text-xs leading-relaxed text-accent-200">
            <i className="ri-information-line mt-0.5" />
            凌晨发布且缺少交叉验证的内容，我们都会标注"待核"，建议天亮后再判断。
          </p>
        </aside>
      </div>
    </section>
  );
}